import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import AppTecnico from '../tecnico/AppTecnico';

/**
 * La puerta del sistema: sin sesión se va al login, y un técnico entra a SU app.
 *
 * ── Por qué el técnico se desvía aquí y no en cada pantalla ──
 *
 * Antes, un técnico entraba al mismo sistema de escritorio que la oficina: el menú lateral
 * con Clientes, Agenda, Equipos y Tickets, en la pantalla de un celular. Para llegar a un
 * trabajo tenía que abrir el menú, entrar a Tickets, filtrar y buscar el suyo entre los de
 * todos. La app le enseña su trabajo del día apenas abre.
 *
 * Este componente ya envuelve TODAS las pantallas protegidas, así que la desviación se
 * escribe una vez y vale también para las pantallas que se agreguen después. Repartirla por
 * cada página sería la clase de regla que se queda a medias: alguien agrega una pantalla
 * nueva, se olvida de ponerla, y un técnico se encuentra con la cartera de la empresa.
 *
 * ── Esto es comodidad, no seguridad ──
 *
 * Lo que un técnico puede ver y tocar lo decide el SERVIDOR, en
 * `backend/services/accesoTecnico.js`. Una pantalla escondida se salta escribiendo la
 * dirección; una puerta cerrada en el servidor, no.
 */
const MANDAN = ['admin', 'superadmin'];

export default function RutaProtegida({ children }) {
  const { usuario, cargando } = useAuth();

  if (cargando) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#0A0E1A', color: '#00E5FF', fontFamily: 'sans-serif' }}>
        Cargando...
      </div>
    );
  }

  if (!usuario) return <Navigate to="/login" replace />;
  if (!MANDAN.includes(usuario.rol)) return <AppTecnico />;
  return children;
}
